import { render, staticRenderFns } from "./pageFicheAuteur.vue?vue&type=template&id=4fa37d0a&scoped=true"
import script from "./pageFicheAuteur.vue?vue&type=script&lang=js"
export * from "./pageFicheAuteur.vue?vue&type=script&lang=js"
import style0 from "./pageFicheAuteur.vue?vue&type=style&index=0&id=4fa37d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa37d0a",
  null
  
)

export default component.exports